import { Select } from '../../../../atoms/select/Select';
import styles from '../CartItem.module.scss';
import React from 'react';

const SelectSize = ({
  selectHeight,
  selectSizeVariant,
  selectSizeLabelPosition,
  selectSizeDefaultValue,
  defaultExpanded,
  options,
  openToTop,
  onSelect,
  customClasses = {},
}) => {
  if (!options || !options?.length) return null;
  const isOneAndOutOfStock = options.length === 1 && options.find((o) => o.isOutOfStock);

  return (
    <Select
      variant={selectSizeVariant}
      selectHeight={selectHeight}
      labelPosition={selectSizeLabelPosition}
      openToTop={openToTop}
      defaultValue={selectSizeDefaultValue}
      onChange={onSelect}
      defaultExpaned={defaultExpanded}
      className={styles.sizeSelect}
      isDisabled={!options.length || !!isOneAndOutOfStock}
      customClasses={customClasses}
    >
      {options.map(({ value: val, label, isOutOfStock, isHiddenFromDropdown }, index) => (
        <Select.Option
          key={val + label}
          index={index}
          label={label}
          value={val}
          isOutOfStock={isOutOfStock}
          htmlContent={<span>{label}</span>}
          isHiddenFromDropdown={isHiddenFromDropdown}
          selected={val === selectSizeDefaultValue}
        />
      ))}
    </Select>
  );
};

export default SelectSize;
